module.exports = __webpack_public_path__ + "flashfood.png?cda1c1d0211ed8f575713c98fa1ab941";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/flashfood.png
// module id = 234
// module chunks = 0